export default "__VITE_ASSET__CnRxpzit__"